
// import { promises } from "dns";
import React, { Fragment, useEffect, useState } from "react";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { useSelector } from "react-redux";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";

interface WidgetProps {
  id: string;
  header: string;
}

const SearchGridWidget = (props: WidgetProps) => {
  const [moreInfo, updateMoreInfo] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const globalParams = useSelector(getParamsSelector);

  useEffect(() => {
    if (globalParams.machine != null) {
     
      if (globalParams.machine.deviceList != null) {
        for (var i = 0; i < globalParams.machine.deviceList.length; i++) {
          if (
            globalParams.machine.deviceList[i].deviceName ==
            globalParams.machine.assemblyName
          ) {
            updateMoreInfo(globalParams.machine.deviceList[i].moreInfo);
          }
        }
      }
    }
  }, [globalParams.machine]);




    const machineDataHandler = () => {
        if (globalParams.machine.dataSource == "D365") {
            alert("The selected machine serial number was not found as a main machine serial number (or assembly serial number) in Machine Analytics. It is possible the selected serial number is listed as part of a different assembly. Please check the customer's other assemblies")
        }
        else {
            
                let urlParams: any = {};
                if (globalParams.machine.machineSn != null) {
                    urlParams =
                        "customerid=" +
                        globalParams.customerID +
                        "&mainMachineSerialNo=" +
                        globalParams.machine.machineSn;
                } else if (globalParams.customerID != null) {
                    urlParams = "customerid=" + globalParams.customerID;
                }

                window.open("https://machinedata.powerplatform.net/" + urlParams, "_self");
            
        }
  };

  if (errorMessage != null) {
    return (
      <>
        <br />
        <ErrorMessage
          text={"No data found"}
          id={props.id}
          header={props.header}
        />
      </>
    );
  }
  if (globalParams.machine == null) {
    return <div>Loading...</div>;
  }
  return (
    <div style={{ padding: "10px" }} className="pp-column-container">
      <div className="pp-column">
        {" "}
        {globalParams.machine.assemblyName +
          " " +
          globalParams.machine.machineSn +
          " " +
          globalParams.machine.projectNr}
      </div>
      <div className="pp-column">
        <span style={{ fontWeight: "bold" }}>More Info: </span> {moreInfo}
      </div>
      <div
        className="pp-column"
        style={{ fontWeight: "bold", color: "blue", cursor: "pointer" }}
        onClick={() => machineDataHandler()}
      >
        {" "}
              Machine Analytics Link      <img src="/assets/img/DI_machine data.png" alt="Icon" style={{ width: 20, height: 20, marginLeft: 5 }} />

      </div>
    </div>
  );
};

export default SearchGridWidget;
